import React from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { useIsRTL, useRouteSlug } from "@/hooks";
import { useAppSelector } from "@/redux/store";
import { selectStaticAssets } from "@/util/selectors";
import SupportImg from "../../images/support.svg";

const NeedHelpFooter = ({ helpDataTiles }) => {
  const routeSlug = useRouteSlug();
  const isRTL = useIsRTL();
  const { t } = useTranslation("needHelp");
  const staticAssets = useAppSelector(selectStaticAssets);

  return (
    <div className="help_text">
      <div>
        <p className={cn({ rtl: isRTL })}>{t("stillNeedHelp")}</p>
        <h4>{t("wereHereToHelp")}</h4>
      </div>
      <div className="help_options">
        {helpDataTiles &&
          helpDataTiles.map((listItem, index) =>
            listItem.onClick ? (
              <button onClick={listItem.onClick} key={index}>
                <div
                  className={listItem.class}
                  style={{
                    backgroundColor: listItem.backgroundColor,
                    color: listItem.color
                  }}
                >
                  <span />
                  <h6>{t(`${listItem.data}`)}</h6>
                </div>
              </button>
            ) : (
              <a
                href={
                  listItem.redirectionLink
                    ? listItem.redirectionLink
                    : `/${routeSlug}${listItem.link}`
                }
                key={index}
                target={listItem.target ? "" : "_blank"}
              >
                <div
                  className={listItem.class}
                  style={{
                    backgroundColor: listItem.backgroundColor,
                    color: listItem.color
                  }}
                >
                  <span />
                  <h6>{t(listItem.data)}</h6>
                </div>
              </a>
            )
          )}
      </div>
      <div className="support_details">
        <a href={`tel:${staticAssets?.csNumberSlug}`}>
          <img src={SupportImg} alt="support" />
          <span>{staticAssets?.csNumberSlug}</span>
        </a>
        <p>{staticAssets?.csTimeSlug}</p>
      </div>
    </div>
  );
};
export default NeedHelpFooter;
